module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0057.jpg?v=897edd6a";